/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Otp_Btn_VerifyInputs */

const es_ab_otp_btn_verify = /** @type {(inputs: Ab_Otp_Btn_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar y publicar`)
};

const gl_ab_otp_btn_verify = /** @type {(inputs: Ab_Otp_Btn_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar e publicar`)
};

const en_ab_otp_btn_verify = /** @type {(inputs: Ab_Otp_Btn_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify and publish`)
};

/**
* | output |
* | --- |
* | "Verify and publish" |
*
* @param {Ab_Otp_Btn_VerifyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_otp_btn_verify = /** @type {((inputs?: Ab_Otp_Btn_VerifyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Otp_Btn_VerifyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_otp_btn_verify(inputs)
	if (locale === "en") return en_ab_otp_btn_verify(inputs)
	return es_ab_otp_btn_verify(inputs)
});